import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function HotClientList() {
    const [allData, setAllData] = useState([]);


    const fetchAllData = async () => {
        try {
            const response = await HomeService.getHotClients();
            console.log("OUY21",response.data);
            
            const formattedData = response?.data?.map((item, index) => ({
                ...item,
                sln: index + 1,
            }));
            setAllData(formattedData || []);
        } catch (error) {
            console.error("Error fetching allData:", error);
            toast.error("Failed to fetch allData.");
        }
    };

    const toggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === true ? false : true;
            await HomeService.updateUserStatus(id, { status: newStatus });
            fetchAllData();

            // toast.success(`Property status updated to ${newStatus}!`);
        } catch (error) {
            toast.error("Failed to update property status.");
            console.error("Error updating status:", error);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, []);

    // Define columns for the data table
    const columns = [
        { name: "SL#", selector: (row) => row.sln, sortable: true },
        { name: "Full Name", selector: (row) => row?.userName },
        { name: "Email", selector: (row) => row?.email },
        { name: "Phone", selector: (row) => row?.phone },
        { name: "City", selector: (row) => row?.city?.name },
        { name: "Client In Hand", selector: (row) => row?.clientInHand },
        
    ];

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid" id="edit-section">
                <div className="mt-5">
                    <h2 className="text-center" style={headLineStyle}>Hot Client List</h2>
                    <hr />




                    <DataTable columns={columns} data={allData} pagination />
                </div>
            </div>
        </div>
    );
}

export default HotClientList;
